module.exports = __webpack_public_path__ + "56194ee461baae7b001f6174e38274e7.pdf";